import { render, staticRenderFns } from "./ItsLogisticTransferSecond.vue?vue&type=template&id=6bd00320&scoped=true&"
import script from "./ItsLogisticTransferSecond.vue?vue&type=script&lang=js&"
export * from "./ItsLogisticTransferSecond.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd00320",
  null
  
)

export default component.exports